import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const HyvIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99556)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M15.717 13.975H14.068L12.329 17.644H12.296L10.557 13.974H8.807L11.492 19.055V21.937H13.089V19.137L15.756 14.092L18.418 21.937H20.058L22.766 13.975H21.08L19.347 19.793L19.254 20.214H19.221L19.123 19.777L17.4 13.975H15.716H15.717ZM8 12H24V24H0V12H3V8H8V12ZM8.22 21.937V13.975H6.628V17.398H3.385V13.975H1.783V21.937H3.385V18.628H6.628V21.937H8.22ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99556'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

HyvIcon.displayName = 'HyvIcon'
